// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomField_label__37v0Q","inline":"CustomField_inline__3B5J0","field":"CustomField_field__tSIzq","input":"CustomField_input__2J3Qt"};